import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';

export default function NewsSection() {
  const hotArticles = getHotArticles(6);
  const categoryLabels: Record<string, string> = {
    football: '足球',
    basketball: '篮球',
    tennis: '网球',
    esports: '电竞',
    others: '综合',
  };

  return (
    <section className="w-full px-4 md:px-6 py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新资讯
            </h2>
            <p className="mt-2 text-sm text-foreground-500">深度解析、赛事前瞻、行业动态一手掌握</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group cursor-pointer"
            >
              <article className="bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 h-full flex flex-col">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 bg-primary-500 text-white text-xs px-2.5 py-1 rounded-full">
                    {categoryLabels[article.category] || article.category}
                  </span>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <h3 className="font-semibold text-foreground-950 text-base leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                    {article.summary}
                  </p>
                  <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between text-xs text-foreground-400">
                    <span>{article.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                    </span>
                  </div>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}